import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/Home/App';
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Photography from './components/Photography/Photography'


export default function Main() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<App />}/> 
          <Route path="/photography" element={<Photography />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Header/>
    <Main/>
    <Footer/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
